import React from "react"
import ChatBoxWindow from "./ChatBotWindow";

export function ChatboxWrapper(){

  const HandleClose = () => {
    const chatBoxWindow = document.getElementById('ChatBotWindow');
    const chatBotWindowOpen = chatBoxWindow.style.display;
    
    chatBoxWindow.style.display = chatBotWindowOpen === 'none' || chatBotWindowOpen === '' ? 'flex' : 'none';
  }

  return (
    <>
      <ChatBoxWindow onClose={() => HandleClose()} />

      <div id='BotButton' onClick={() => HandleClose()}>
        <img alt='' src='/Icons/AIChat.svg' height={35} width={35} />
      </div>
    </>
  );
}